import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import isEmpty from 'lodash/isEmpty';
import { CardEmailInput } from '../../components/payments';
import CardFields from './CardFields';
import BillingFields from './BillingFields';

class BasicFields extends Component {

  renderCardFields = () => {
    const {
      cardType,
      cardNumber,
      cardExpMonth,
      cardExpYear,
      cardCVC,
      showCardFields,
      onChangeField,
    } = this.props;

    if (!showCardFields) {
      return null;
    }

    return (
      <CardFields
        cardType={cardType}
        cardNumber={cardNumber}
        cardExpMonth={cardExpMonth}
        cardExpYear={cardExpYear}
        cardCVC={cardCVC}
        onChangeInput={onChangeField}
      />
    );
  };

  render() {
    const {
      showEmail,
      checkoutEmail,
      addressLine1,
      addressCity,
      addressState,
      addressZip,
      addressCountry,
      onChangeField,
      showBillingFields,
    } = this.props;

    return (
      <BasicFieldsWrapper>
        {showEmail && (
          <div className="row">
            <div className="col-lg-12 col-md-12 col-xs-12">
              <CardEmailInput
                onChange={onChangeField('checkoutEmail')}
                required
                className="border-radius-4"
                name="checkoutEmail"
                style={styles.input}
                defaultValue={checkoutEmail}
              />
            </div>
          </div>
        )}
        <BillingFields
          addressLine1={addressLine1}
          addressCity={addressCity}
          addressState={addressState}
          addressZip={addressZip}
          addressCountry={addressCountry}
          onChangeInput={onChangeField}
          showFields={showBillingFields}
        />
        {this.renderCardFields()}
      </BasicFieldsWrapper>
    );
  }
}

const BasicFieldsWrapper = styled.div`
  .card-number-wrapper {
    text-align: right;

    .card-logos {
      img {
        margin: 0 2px 5px 0;
      }
    }
  }

  .input-area {
    position: relative;

    .error-view {
      position: absolute;
      bottom: 0;
      color: #F44336;
      font-size: 1.2rem;
      left: 1px;
    }
  }
`;

const styles = {
  input: {
    height: 46,
    fontSize: '1.5rem',
  },
};

BasicFields.propTypes = {
  showEmail: PropTypes.bool,
  showCardFields: PropTypes.bool,
  checkoutEmail: PropTypes.string,
  addressLine1: PropTypes.string,
  addressCity: PropTypes.string,
  addressState: PropTypes.string,
  addressZip: PropTypes.string,
  addressCountry: PropTypes.string,
  cardType: PropTypes.any,
  cardNumber: PropTypes.string,
  cardExpMonth: PropTypes.any,
  cardExpYear: PropTypes.any,
  cardCVC: PropTypes.string,
  onChangeField: PropTypes.func,
  showBillingFields: PropTypes.object,
};

BasicFields.defaultProps = {
  showEmail: false,
  showCardFields: true,
  checkoutEmail: '',
  addressLine1: '',
  addressCity: '',
  addressState: '',
  addressZip: '',
  addressCountry: '',
  cardType: '',
  cardNumber: '',
  cardExpMonth: '',
  cardExpYear: '',
  cardCVC: '',
  onChangeField: () => {},
  showBillingFields: {
    addressLine1: true,
    addressCity: true,
    addressState: true,
    addressZip: true,
    addressCountry: true,
  },
};

export default BasicFields;
